// extracted by mini-css-extract-plugin
export default {"component":"PdfDownloadRowItem_component__l7dh2","label":"PdfDownloadRowItem_label__GfIrI","icon":"PdfDownloadRowItem_icon__8fUNT"};